import React, { useState } from 'react';
import { Modal, Button, TextField, Grid, Box } from '@mui/material';

function MuestraModal({ open, handleClose, handleSave, usuarioActual }) {
  const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
  const [descripcionMuestra, setDescripcionMuestra] = useState('');
  const [ingresadoPor, setIngresadoPor] = useState(usuarioActual || ''); // Prellenar si se pasa el valor
  const [fechaIngreso, setFechaIngreso] = useState(new Date().toISOString().split('T')[0]); // Fecha actual
  const [modificacion, setModificacion] = useState(0);
  const [error, setError] = useState(''); // Para mostrar errores

  const handleGuardar = async () => {
    if (!descripcionMuestra) {
      setError('La descripción de la muestra es obligatoria.');
      return;
    }

    // Datos a enviar a la API
    const nuevaMuestra = {
      descripcionMuestra,
      ingresadoPor,
      fechaIngreso,
      modificacion,
    };

    try {
      // Llamada POST a la API
      const response = await fetch(`${server}/CdmTiposDeMuestras`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(nuevaMuestra), // Convertir el objeto a JSON para la petición
      });

      if (response.ok) {
        // Si la petición fue exitosa
        const data = await response.json();
        console.log('Muestra guardada:', data);

        // Aquí puedes llamar a la función `handleSave` para notificar al componente padre
        handleSave(data);

        // Limpiar campos después de guardar
        setDescripcionMuestra('');
        setIngresadoPor(usuarioActual || ''); // Vuelve a prellenar el campo si aplica
        setFechaIngreso(new Date().toISOString().split('T')[0]);
        setModificacion(0);

        // Cerrar modal
        handleClose();
      } else {
        // Si hubo un error en la petición
        const errorData = await response.json();
        setError(`Error al guardar la muestra: ${errorData.message}`);
      }
    } catch (error) {
      console.error('Error al guardar la muestra:', error);
      setError('Ocurrió un error al guardar la muestra.');
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          padding: '20px',
          backgroundColor: 'white',
          margin: '50px auto',
          maxWidth: '500px',
          borderRadius: '8px',
          boxShadow: 24,
        }}
      >
        <h2>Agregar Muestra</h2>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Descripción de la Muestra"
              value={descripcionMuestra}
              onChange={(e) => {
                setDescripcionMuestra(e.target.value);
                setError(''); // Limpiar el mensaje de error si el usuario empieza a escribir
              }}
              error={!!error}
              helperText={error}
            />
          </Grid>
          <Grid item xs={12} style={{ textAlign: 'right' }}>
            <Button onClick={handleGuardar} variant="contained" color="primary">
              Guardar
            </Button>
            <Button
              onClick={handleClose}
              variant="outlined"
              color="secondary"
              style={{ marginLeft: '10px' }}
            >
              Cancelar
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}

export default MuestraModal;
